export const SET_COLOR = 'SET_COLOR';
export const SET_VARIANT = 'SET_VARIANT';
export const SET_QUANTITY = 'SET_QUANTITY';
export const FETCH_PRODUCT_REQUEST = 'FETCH_PRODUCT_REQUEST';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAILURE = 'FETCH_PRODUCT_FAILURE';
